import { render, staticRenderFns } from "./modal.pug?vue&type=template&id=22d1fde0&lang=pug&external"
import script from "./modal.js?vue&type=script&lang=js&external"
export * from "./modal.js?vue&type=script&lang=js&external"
import style0 from "./modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d1fde0')) {
      api.createRecord('22d1fde0', component.options)
    } else {
      api.reload('22d1fde0', component.options)
    }
    module.hot.accept("./modal.pug?vue&type=template&id=22d1fde0&lang=pug&external", function () {
      api.rerender('22d1fde0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/index.vue"
export default component.exports